import React, {useState} from 'react';
import {Redirect} from 'react-router-dom';

const DatacentreForm = ({api}) => {

    const [dcName, setDcName] = useState("");
    const [formError, setFormError] = useState("");
    const [formDone, setFormDone] = useState(false);

    const createDatacentre = async(evt) => {
        evt.preventDefault();
        setFormError('');
        let result = await api.createDatacentre(dcName).catch(err => {
            setFormError(err.message);
        });
        console.log(result);
        if(!!result) {
            setFormDone(true);
        }
    }

    const dcNameChange = (evt) => {
        setDcName(evt.target.value);
    }

    if(formDone) {
        return <Redirect to="/"></Redirect>
    }

    return <form className="LoginForm" onSubmit={createDatacentre}>
        <div className="form-group">
            <label htmlFor="username">Datacentre Name</label>
            <input type="text" className="form-control" required id="username" value={dcName} onChange={dcNameChange} />
        </div>
        <span className="text-danger">{formError}</span>
        <button type="submit" className="btn btn-primary float-right">Submit</button>
    </form>
}

export default DatacentreForm;